import useVisibility from "../../hooks/useVisibility";
import { MetricPanelProps } from "../../services/types";
import { getMetricGroupChartId, getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import SimpleBarChart from "../charts/SimpleBarChart";
import DisaggregateMetricCardAlt from "../DisaggregateMetricCardAlt";

const EconomyMetrics = ({ indicators, categorizedData, geoDetails, tab, geoTag, selectionActive }: MetricPanelProps) => {   
    // check window height for toggling chart display
    const { ref: sectionRef, isVisible } = useVisibility();

    const bgColor = "#225591";
    const barColor = "#00A18A";

    const econOrders = getMetricGroupOrderIds(tab);

    const sortedEconMetrics = econOrders.map((order: number[]) => 
        categorizedData.Economy
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Economy data:', sortedEconMetrics);

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }


    return (
        <div ref={sectionRef}>
            {isVisible ? (
            <div className="grid grid-cols-3 gap-4 place-items-start ml-4 mt-8">
                <div className="col-span-3 w-full pr-4">
                    {categorizedData.Economy.filter(metric => 
                        [getMetricGroupChartId(tab, "industry")].includes(metric.id) // Employment By Industry
                    ).map(metric => (
                        <DisaggregateMetricCardAlt
                            key={metric.id}
                            id={metric.id}
                            metric={metric}
                            title={metric.name}
                            subText="Total Jobs:"
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showValue={true}
                            color={bgColor}
                            altFormatting={true}
                        />
                    ))}
                    <SimpleBarChart indicators={indicators} title="Employment By Industry" tab="Economy" chartName="industry" height="h-96" barColor={barColor} reverseOrder={false} topFive={false}/>
                </div>
            </div>
            ) : 
            <div className="col-span-3 min-h-[700px] mx-auto border-t overflow-hidden">
                <p className="pt-4 text-xs text-port-text text-center px-10 mb-8">Scroll down or close the storymap window to see selected area statistics.</p>
            </div>
            }
        </div>
    );
}

export default EconomyMetrics;